<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-ios-switch`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M47 25c0-7.732-6.268-14-14-14H15C7.268 11 1 17.268 1 25s6.268 14 14 14h18c7.732 0 14-6.268 14-14zM15 15h18c5.523 0 10 4.477 10 10s-4.477 10-10 10H15C9.477 35 5 30.523 5 25s4.477-10 10-10zm18 4a6 6 0 110 12 6 6 0 010-12zm-2 6a2 2 0 114 0 2 2 0 01-4 0z"/></svg>
</template>
<script>

export default {
  name: 'IconIosSwitch',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
